import { cn } from "@/modern/utils";
import { useChecklistItemsData } from "@/react/hooks/entityHooks/useChecklistItemsData";

interface ChecklistProgressBarProps {
  checklistId: number | string;
  className?: string;
}

export const ChecklistProgressBar = ({ checklistId, className }: ChecklistProgressBarProps) => {
  const { completedItems, totalItems, completionPercentage } = useChecklistItemsData(checklistId);

  const getProgressColor = (_percentage: number) => {
    return "bg-success/30";
  };

  return (
    <div className={cn("flex items-center gap-4 text-xs text-muted-foreground pr-3", className)}>
      <div className="h-1.5 bg-success/10 relative overflow-hidden flex-1 rounded-full">
        <div className={cn("h-full transition-all duration-500 ease-out", getProgressColor(completionPercentage))} style={{ width: `${completionPercentage}%` }} />
      </div>
      <div className="flex items-center gap-1.5">
        <span>
          {completedItems}/{totalItems}
        </span>
      </div>
    </div>
  );
};
